/**
 * assets/noonie-product.js
 * Noonie product page â€” gallery, native bundle builder, quantity, cart drawer,
 * sticky ATC, and zoom. Mix-and-match colors are saved as cart properties.
 */
(function () {
  'use strict';

  function init() {
    const root = document.querySelector('noonie-product-v2');
    if (!root || root._init) return;
    root._init = true;

    // Parse product JSON
    const jsonEl = root.querySelector('[data-noonie-product-json]');
    if (!jsonEl) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); }
    catch (e) { console.error('[noonie] bad JSON', e); return; }

    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const productUrl  = root.dataset.productUrl || window.location.pathname;
    const colorIndex  = parseInt(root.dataset.colorIndex, 10);
    const bundleIndex = parseInt(root.dataset.bundleIndex, 10);

    // Refs
    const variantInput  = root.querySelector('[data-np-variant-id]');
    const priceEl       = root.querySelector('[data-np-price]');
    const compareEl     = root.querySelector('[data-np-compare]');
    const saveEl        = root.querySelector('[data-np-save]');
    const srPriceEl     = root.querySelector('[data-np-sr-price]');
    const atcBtn        = root.querySelector('[data-np-atc]');
    const atcLabel      = root.querySelector('[data-np-atc-label]');
    const qtyInput      = root.querySelector('[data-np-qty]');
    const stickyBar     = root.querySelector('[data-np-sticky]');
    const stickyPrice   = root.querySelector('[data-np-sticky-price]');
    const stickyAtc     = root.querySelector('[data-np-sticky-atc]');
    const bundleInputs  = Array.from(root.querySelectorAll('[data-np-bundle-input]'));
    const clipInputs    = Array.from(root.querySelectorAll('[data-np-clip-color]'));
    const clipPickers   = Array.from(root.querySelectorAll('[data-np-clip-picker]'));
    const propertyInputs = Array.from(root.querySelectorAll('[data-np-property]'));
    const selectionSummary = root.querySelector('[data-np-selection-summary]');

    console.log('[noonie v2] init â€” atcBtn:', atcBtn, 'bundleInputs:', bundleInputs.length);

    // ---- Money ----
    function formatMoney(cents) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      const fmt = moneyFormat;
      const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      function delimit(n, p, t, d) {
        p = p == null ? 2 : p; t = t || ','; d = d || '.';
        if (isNaN(n) || n == null) return '0';
        n = (n/100).toFixed(p);
        const parts = n.split('.');
        return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1'+t) + (parts[1] ? d+parts[1] : '');
      }
      let val;
      switch (m ? m[1] : 'amount') {
        case 'amount': val = delimit(cents,2); break;
        case 'amount_no_decimals': val = delimit(cents,0); break;
        case 'amount_with_comma_separator': val = delimit(cents,2,'.',','); break;
        case 'amount_no_decimals_with_comma_separator': val = delimit(cents,0,'.',','); break;
        default: val = delimit(cents,2);
      }
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, val);
    }

    // ---- Variant resolution ----
    function getSelectedOptions() {
      const opts = new Array(product.options.length).fill(null);
      const firstColor = clipInputs.find(i => i.checked && parseInt(i.dataset.clipIndex, 10) === 1);
      const bundle = bundleInputs.find(i => i.checked);
      if (firstColor && colorIndex > -1) opts[colorIndex] = firstColor.value;
      if (bundle && bundleIndex > -1) opts[bundleIndex] = bundle.value;
      const cv = currentVariant();
      if (cv) opts.forEach((v,i) => { if (v===null) opts[i] = cv.options[i]; });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(v => v.options.every((val,i) => opts[i]===null || val===opts[i]));
    }

    function currentVariant() {
      const id = parseInt(variantInput && variantInput.value, 10);
      return product.variants.find(v => v.id === id) || null;
    }

    // ---- Price / ATC updates ----
    function updatePrice(variant) {
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) { compareEl.hidden = !sale; const s = compareEl.querySelector('s')||compareEl; s.textContent = sale ? formatMoney(variant.compare_at_price) : ''; }
      if (saveEl) { saveEl.hidden = !sale; if (sale) { const p = Math.round((variant.compare_at_price-variant.price)/variant.compare_at_price*100); saveEl.textContent = 'SAVE '+p+'%'; } }
      if (srPriceEl) srPriceEl.textContent = 'Price: '+formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    }

    function updateAtc(variant) {
      const avail = variant.available;
      if (atcBtn) { atcBtn.disabled = !avail; atcLabel.innerHTML = avail ? 'ADD TO BAG &bull; <span data-np-atc-price>'+formatMoney(variant.price)+'</span>' : 'SOLD OUT'; }
      if (stickyAtc) { stickyAtc.disabled = !avail; stickyAtc.textContent = avail ? 'ADD TO BAG' : 'SOLD OUT'; }
    }

    function setUnavailable() {
      if (atcBtn) { atcBtn.disabled = true; atcLabel.textContent = 'UNAVAILABLE'; }
      if (stickyAtc) { stickyAtc.disabled = true; stickyAtc.textContent = 'UNAVAILABLE'; }
      if (saveEl) saveEl.hidden = true;
      if (compareEl) compareEl.hidden = true;
    }

    function selectedPackCount() {
      const bundle = bundleInputs.find(i => i.checked);
      return bundle ? parseInt(bundle.dataset.packCount, 10) || 1 : 1;
    }

    function selectedColors() {
      const count = selectedPackCount();
      const colors = [];
      for (let index = 1; index <= count; index += 1) {
        const selected = clipInputs.find(i => i.checked && parseInt(i.dataset.clipIndex, 10) === index);
        if (selected) colors.push(selected.value);
      }
      return colors;
    }

    function updateBuilder() {
      const count = selectedPackCount();
      clipPickers.forEach(picker => {
        const index = parseInt(picker.dataset.clipIndex, 10);
        picker.hidden = index > count;
        const chosen = clipInputs.find(i => i.checked && parseInt(i.dataset.clipIndex, 10) === index);
        const label = picker.querySelector('[data-np-clip-label]');
        if (label && chosen) label.textContent = chosen.value.toUpperCase();
      });

      const colors = selectedColors();
      propertyInputs.forEach(input => {
        const index = parseInt(input.dataset.npProperty, 10);
        const active = index <= count;
        input.disabled = !active;
        input.value = active ? (colors[index - 1] || '') : '';
      });

      if (selectionSummary) {
        const label = count === 1 ? 'your color' : 'your set';
        selectionSummary.innerHTML = '<span>' + label + '</span><strong>' + colors.join(' + ') + '</strong>';
      }
    }

    // ---- Option change ----
    function onOptionChange(isInit) {
      const opts = getSelectedOptions();
      const variant = findVariant(opts);

      updateBuilder();

      if (!variant) {
        setUnavailable();
        return;
      }

      variantInput.value = variant.id;
      updatePrice(variant);
      updateAtc(variant);
      updateMedia(variant);

      if (!isInit && window.history.replaceState) {
        window.history.replaceState({}, '', productUrl + '?variant=' + variant.id);
      }

      if (qtyInput) {
        const rule = variant.quantity_rule || {};
        const min = rule.min || 1;
        qtyInput.min = min;
        if (rule.max) qtyInput.max = rule.max;
        else qtyInput.removeAttribute('max');
        qtyInput.step = rule.increment || 1;
        if (parseInt(qtyInput.value, 10) < min) qtyInput.value = min;
      }
    }

    // ---- ATC click ----
    async function onAtcClick(e) {
      e.preventDefault();
      e.stopPropagation();

      const variant = currentVariant();
      if (!variant) {
        console.error('[noonie v2] no selected variant');
        return;
      }

      const qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
      const btn = e.currentTarget;
      const orig = btn.innerHTML;

      btn.disabled = true;
      btn.textContent = 'ADDING...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variant.id,
              quantity: qty,
              properties: selectedColors().reduce((props, color, index) => {
                props['Clip ' + (index + 1)] = color;
                return props;
              }, {})
            }]
          })
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'cart error');

        btn.textContent = 'ADDED âœ“';
        setTimeout(() => {
          btn.disabled = false;
          btn.innerHTML = orig;
        }, 1800);

        const cart = await fetch('/cart.js').then(r => r.json());

        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && !drawer.hasAttribute('auto-open')) {
          drawer.setAttribute('auto-open', '');
        }

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'noonie-product',
            data: { itemCount: cart.item_count }
          }
        }));

        const bubble = document.getElementById('cart-bubble-text');
        if (bubble) {
          bubble.textContent = cart.item_count;
          const hidden = bubble.closest('[hidden]');
          if (hidden) hidden.removeAttribute('hidden');
        }
      } catch (err) {
        console.error('[noonie v2] error:', err);
        btn.disabled = false;
        btn.innerHTML = orig;
      }
    }

    // ---- Gallery ----
    const mediaEls = Array.from(root.querySelectorAll('[data-np-media]'));
    const thumbEls = Array.from(root.querySelectorAll('[data-np-thumb]'));
    let activeIdx = Math.max(0, mediaEls.findIndex(e => e.classList.contains('is-active')));

    function showMedia(index) {
      const n = mediaEls.length; if (!n) return;
      const idx = ((index%n)+n)%n;
      mediaEls.forEach((el,i) => { const a=i===idx; el.classList.toggle('is-active',a); el.hidden=!a; if(!a){const v=el.querySelector('video');if(v)v.pause();} });
      thumbEls.forEach((el,i) => { el.classList.toggle('is-active',i===idx); el.setAttribute('aria-selected',i===idx?'true':'false'); });
      activeIdx = idx;
    }

    function updateMedia(variant) {
      if (!variant.featured_media || !mediaEls.length) return;
      const idx = mediaEls.findIndex(el => parseInt(el.dataset.mediaId,10) === variant.featured_media.id);
      if (idx > -1) showMedia(idx);
    }

    const prev = root.querySelector('[data-np-prev]');
    const next = root.querySelector('[data-np-next]');
    if (prev) prev.addEventListener('click', () => showMedia(activeIdx-1));
    if (next) next.addEventListener('click', () => showMedia(activeIdx+1));
    thumbEls.forEach((t,i) => t.addEventListener('click', () => showMedia(i)));

    const track = root.querySelector('[data-np-track]');
    if (track) {
      let sx = null;
      track.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive:true });
      track.addEventListener('touchend', e => { if(sx===null)return; const dx=e.changedTouches[0].clientX-sx; if(Math.abs(dx)>48)showMedia(activeIdx+(dx<0?1:-1)); sx=null; }, { passive:true });
    }

    // ---- Quantity ----
    if (qtyInput) {
      const minus = root.querySelector('[data-np-qty-minus]');
      const plus  = root.querySelector('[data-np-qty-plus]');
      const step  = () => parseInt(qtyInput.step,10)||1;
      const min   = () => parseInt(qtyInput.min,10)||1;
      const max   = () => qtyInput.max ? parseInt(qtyInput.max,10) : Infinity;
      const clamp = v => Math.min(Math.max(v,min()),max());
      if (minus) minus.addEventListener('click', () => { qtyInput.value = clamp((parseInt(qtyInput.value,10)||min())-step()); });
      if (plus)  plus.addEventListener('click',  () => { qtyInput.value = clamp((parseInt(qtyInput.value,10)||min())+step()); });
      qtyInput.addEventListener('change', () => { const v=parseInt(qtyInput.value,10); qtyInput.value=isNaN(v)?min():clamp(v); });
    }

    // ---- Sticky bar ----
    if (stickyBar && atcBtn && 'IntersectionObserver' in window) {
      const obs = new IntersectionObserver(entries => { entries.forEach(e => { stickyBar.hidden = e.isIntersecting; }); }, { rootMargin:'0px 0px -10% 0px' });
      obs.observe(atcBtn);
    }

    // ---- Lightbox ----
    const lightbox = root.querySelector('[data-np-lightbox]');
    if (lightbox) {
      const openBtn  = root.querySelector('[data-np-open-lightbox]');
      const closeBtn = root.querySelector('[data-np-close-lightbox]');
      const lbImg    = root.querySelector('[data-np-lightbox-img]');
      const openLb = () => { const a=mediaEls[activeIdx]; if(!a||!a.dataset.zoomSrc)return; lbImg.src=a.dataset.zoomSrc; lightbox.showModal ? lightbox.showModal() : lightbox.setAttribute('open',''); };
      const closeLb = () => { lightbox.close ? lightbox.close() : lightbox.removeAttribute('open'); lbImg.src=''; };
      if (openBtn)  openBtn.addEventListener('click', openLb);
      if (closeBtn) closeBtn.addEventListener('click', closeLb);
      lightbox.addEventListener('click', e => { if(e.target===lightbox) closeLb(); });
    }

    // ---- Wire up events ----
    bundleInputs.forEach(i => i.addEventListener('change', () => onOptionChange(false)));
    clipInputs.forEach(i => i.addEventListener('change', () => onOptionChange(false)));
    if (atcBtn)    atcBtn.addEventListener('click',    onAtcClick);
    if (stickyAtc) stickyAtc.addEventListener('click', onAtcClick);

    // Initial sync
    onOptionChange(true);
    console.log('[noonie v2] fully initialized');
  }

  // Run immediately and also after DOM events as fallback
  init();
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);

})();